module.exports = __webpack_public_path__ + "static/media/person-icon.6282a372.svg";